Router = App.loadClass 'core::Router'

class exports.SlackFilesRouter extends Router

    prefix: 'SlackFiles'
    module_name: 'SlackFilesRouter'

    register: () ->
        @module  = angular.module @module_name, ['ui.router', 'ui.bootstrap']


    registerRoutes: ($stateProvider, $urlRouterProvider) ->
        $stateProvider
            .state 'admin.slack-files',
                url: '/slack-files'
                templateUrl: 'backend/admin/tools/slack-files/sidebar-layout'
                controller: 'SlackFiles.Controllers.SlackFilesSidebarController'

            .state 'admin.slack-files.fullpage',
                views:
                    'fullpage':
                        templateUrl: 'backend/admin/tools/slack-files/fullpage-layout'
                        controller: 'SlackFiles.Controllers.SlackFilesController'
